import {
  SHOW_MODAL,
  SHOW_MODAL_PRODUCTRESERVATION,
  SHOW_MODAL_CANCELMYPRODUCTRESERVATION,
  SHOW_MODAL_COMPANY_CONNECT_WITH_CODE,
  SHOW_MODAL_COMPANY_PROVIDER_REQUEST,
  SHOW_REMOVE_MODAL,
  HIDE_MODAL,
  SHOW_MODAL_PRODUCT_LOCATION
} from "../actions/types";
import { v4 as uuid } from 'uuid';

export default function (state = "", action) {
  const { type, message = "", header = "", data = null, saveEvent = null } = action;
console.log( type );
  switch (type) {
    case SHOW_MODAL:
    case SHOW_MODAL_PRODUCTRESERVATION:
	case SHOW_MODAL_CANCELMYPRODUCTRESERVATION:
	case SHOW_MODAL_COMPANY_CONNECT_WITH_CODE:
	case SHOW_MODAL_COMPANY_PROVIDER_REQUEST:
	case SHOW_REMOVE_MODAL:
	case SHOW_MODAL_PRODUCT_LOCATION:		
		var messageKey = uuid().slice(0,8);
      return {
		message_id: messageKey,
		header: header,
        message: message,
		data: data,
		saveEvent:saveEvent,
		type: type,
		show: true
      };
    default:
      return false;
  }
}